import { useQuery } from '@tanstack/react-query'
import { bannerService } from '../services/bannerService'
import { useToast } from '../../view/components/ui/use-toast'
import { useEffect } from 'react'
import { BannerOrigin, BannerType } from '../entities/Banner'

export const useBanners = (type: BannerType, origin?: BannerOrigin) => {
  const { toast } = useToast()

  const { data, isLoading, isError, refetch } = useQuery({
    queryKey: ['banners', type, origin],
    queryFn: () => bannerService.getBanners(type, origin),
    retry(failureCount) {
      return failureCount < 2
    },
  })

  useEffect(() => {
    if (isError) {
      toast({
        variant: 'destructive',
        title: 'Erro ao carregar banners. Tente novamente mais tarde.',
      })
    }
  }, [isError, toast])

  return {
    banners: data,
    isLoading,
    refetch,
  }
}
